import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Register } from 'src/app/common-components/register/models/register';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getLocationPrivileges } from 'src/app/privileges/privileges.selector';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { LocationPrivileges } from '../models/location-privileges';
import { LocationsFilterOption } from '../models/locations-filter-option';
import { LocationsOrderingOptions, LocationsRegisterOptions } from '../models/locations-register-options';
import { LocationsRegisterListItem } from '../models/locations-register-results.model';
import {
   createLocation,
   locationsRegisterAdapterActions,
   locationsRegisterInitialFilter,
} from '../state/locations-register.actions';
import * as locationsRegisterReducer from '../state/locations-register.reducer';

@Component({
    selector: 'ndt-locations-register',
    templateUrl: './locations-register.component.html',
    standalone: false
})
export class LocationsRegisterComponent
   extends Register<LocationsRegisterListItem, LocationsRegisterOptions, LocationsOrderingOptions>
   implements OnInit
{
   columns: string[] = ['address','name', 'city', 'state', 'zipcode', 'locationActionsMenu'];

   entityName = 'Location';

   locationPrivileges$: Observable<LocationPrivileges>;

   filters: LocationsFilterOption[];

   constructor(public store: Store) {
      super(store, locationsRegisterReducer.selectors, locationsRegisterAdapterActions);
      this.locationPrivileges$ = store.pipe(select(getLocationPrivileges));

      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: LocationsFilterOption[] = [
                  {
                     field: 'AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
         });
   }

   ngOnInit() {
      this.store.dispatch(locationsRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
   }

   onCreate(): void {
      this.store.dispatch(createLocation());
   }
}
